import { render, staticRenderFns } from "./repair-create-before-swiper.vue?vue&type=template&id=61ed9bb8"
import script from "./repair-create-before-swiper.vue?vue&type=script&lang=js"
export * from "./repair-create-before-swiper.vue?vue&type=script&lang=js"
import style0 from "./repair-create-before-swiper.vue?vue&type=style&index=0&id=61ed9bb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports